const pageNameKey = "initialStructurePanel";

export const initialStructurePanelEn = {
  [pageNameKey]: {
    subtitle: "Initial Machine Structure",
    lastReceivedAt: "Last received: ",
    errorFetchingLastUpdatedAt: "Failed to retrieve the last updated time.",
    noTimestampAvailable: "Timestamp is not available",
  },
};

export const initialStructurePanelPtBr = {
  [pageNameKey]: {
    subtitle: "Estrutura Inicial",
    lastReceivedAt: "Última recebida: ",
    errorFetchingLastUpdatedAt: "Falha ao recuperar a última atualização.",
    noTimestampAvailable: "Timestamp não disponível",
  },
};

export const initialStructurePanelDe = {
  [pageNameKey]: {
    subtitle: "Initiale Maschinenstruktur",
    lastReceivedAt: "Zuletzt empfangen: ",
    errorFetchingLastUpdatedAt:
      "Fehler beim Abrufen der letzten Aktualisierung.",
    noTimestampAvailable: "Zeitstempel nicht verfügbar",
  },
};

export const initialStructurePanelZhHans = {
  [pageNameKey]: {
    subtitle: "初始机器结构",
    lastReceivedAt: "最后接收时间: ",
    errorFetchingLastUpdatedAt: "获取最后更新时间失败。",
    noTimestampAvailable: "时间戳不可用",
  },
};

export const initialStructurePanelIt = {
  [pageNameKey]: {
    subtitle: "Struttura Iniziale della Macchina",
    lastReceivedAt: "Ultimo ricevuto: ",
    errorFetchingLastUpdatedAt:
      "Impossibile recuperare l'ultima data di aggiornamento.",
    noTimestampAvailable: "Timestamp non disponibile",
  },
};

export const initialStructurePanelEs = {
  [pageNameKey]: {
    subtitle: "Estructura Inicial de la Máquina",
    lastReceivedAt: "Último recibido: ",
    errorFetchingLastUpdatedAt: "Error al recuperar la última actualización.",
    noTimestampAvailable: "Timestamp no disponible",
  },
};

export const initialStructurePanelNl = {
  [pageNameKey]: {
    errorFetchingLastUpdatedAt: "Fout bij het ophalen van de laatste update.",
    lastReceivedAt: "Laatst ontvangen: ",
    noTimestampAvailable: "Timestamp niet beschikbaar",
    subtitle: "Initiële structuur",
  },
};

export const initialStructurePanelTr = {
  [pageNameKey]: {
    errorFetchingLastUpdatedAt: "Son güncellenme saati alınamadı.",
    lastReceivedAt: "Son alınan:",
    noTimestampAvailable: "Zaman damgası kullanılamıyor",
    subtitle: "İlk Makine Yapısı",
  },
};
